module.exports = {"511302001":"中城街道","511302002":"北城街道","511302003":"西城街道","511302004":"东南街道","511302005":"舞凤街道","511302006":"新建街道","511302007":"华凤街道","511302008":"和平路街道","511302009":"潆溪街道","511302010":"荆溪街道","511302011":"西山街道","511302104":"共兴镇","511302105":"金台镇","511302106":"芦溪镇","511302107":"李家镇","511302108":"双桥镇","511302110":"搬罾镇","511302111":"大林镇","511302112":"辉景镇","511302113":"永丰镇","511302200":"新复乡","511302201":"同仁乡","511302205":"梵殿乡","511302206":"顺河乡","511302207":"灯台乡","511302209":"龙桂乡","511302211":"桂花乡","511302212":"凤山乡","511302213":"渔溪乡","511302401":"潆华工业集中区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511302.json
// module id = 2157
// module chunks = 0